export const timeStampToTimeAgo = (timestamp) => {
  const currentTime = new Date();
  const targetTime = new Date(timestamp * 1000);
  const timeDifferenceInSeconds = Math.floor((currentTime - targetTime) / 1000);
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;
  const month = day * 30;
  const year = day * 365;

  if (timeDifferenceInSeconds < minute) {
    const seconds = timeDifferenceInSeconds === 1 ? "Sec" : "Sec";
    return `${timeDifferenceInSeconds} ${seconds} ago`;
  } else if (timeDifferenceInSeconds < hour) {
    const minutes = Math.floor(timeDifferenceInSeconds / minute);
    return `${minutes} ${minutes === 1 ? "Min" : "Mins"} ago`;
  } else if (timeDifferenceInSeconds < day) {
    const hours = Math.floor(timeDifferenceInSeconds / hour);
    return `${hours} ${hours === 1 ? "Hr" : "Hrs"} ago`;
  } else if (timeDifferenceInSeconds < week) {
    const days = Math.floor(timeDifferenceInSeconds / day);
    return `${days} ${days === 1 ? "Day" : "Days"} ago`;
  } else if (timeDifferenceInSeconds < month) {
    const weeks = Math.floor(timeDifferenceInSeconds / week);
    return `${weeks} ${weeks === 1 ? "Week" : "Weeks"} ago`;
  } else if (timeDifferenceInSeconds < year) {
    const months = Math.floor(timeDifferenceInSeconds / month);
    return `${months} ${months === 1 ? "Month" : "Months"} ago`;
  } else {
    const years = Math.floor(timeDifferenceInSeconds / year);
    return `${years} ${years === 1 ? "Year" : "Years"} ago`;
  }
};

export const slaTime = (targetTimestamp) => {
  const currentTime = new Date();
  const targetTime = new Date(targetTimestamp * 1000);
  const timeDifferenceInSeconds = Math.floor((targetTime - currentTime) / 1000);
  const absTimeDifference = Math.abs(timeDifferenceInSeconds);
  
  if (timeDifferenceInSeconds <= 0) {
    return `-${slaTimeFormat(absTimeDifference)}`;
  } else {
    return slaTimeFormat(absTimeDifference);
  }
};
const slaTimeFormat = (timeInSeconds) => {
  const minute = 60;
  const hour = minute * 60;
  const day = hour * 24;
  const week = day * 7;
  const month = day * 30;
  const year = day * 365;
  if (timeInSeconds < minute) {
    return `${timeInSeconds === 1 ? "1 Min" : `${timeInSeconds} Mins`}`;
  } else if (timeInSeconds < hour) {
    const minutes = Math.floor(timeInSeconds / minute);
    return `${minutes === 1 ? "1 Min" : `${minutes} Mins`}`;
  } else if (timeInSeconds < day) {
    const hours = Math.floor(timeInSeconds / hour);
    return `${hours === 1 ? "1 Hour" : `${hours} Hours`}`;
  } else if (timeInSeconds < week) {
    const days = Math.floor(timeInSeconds / day);
    return `${days === 1 ? "1 Day" : `${days} Days`}`;
  } else if (timeInSeconds < month) {
    const weeks = Math.floor(timeInSeconds / week);
    return `${weeks === 1 ? "1 Week" : `${weeks} Weeks`}`;
  } else if (timeInSeconds < year) {
    const months = Math.floor(timeInSeconds / month);
    return `${months === 1 ? "1 Month" : `${months} Months`}`;
  } else {
    const years = Math.floor(timeInSeconds / year);
    return `${years === 1 ? "1 Year" : `${years} Years`}`;
  }
};

export const exactDateAndTime = (timestamp) => {
  let milliseconds = timestamp * 1000;
  let dateObject = new Date(milliseconds);
  let dayAbbreviation = dateObject.toLocaleDateString("en-US", {
    weekday: "short",
  });
  
  let formattedDate = dateObject.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  let formattedTime = dateObject.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  let formattedDateTime = `${formattedDate} at ${formattedTime}`;

  return formattedDateTime;
};

export const exactDate = (timestamp) => {
  let milliseconds = timestamp * 1000;
  let dateObject = new Date(milliseconds);
  let dayAbbreviation = dateObject.toLocaleDateString("en-US", {
    weekday: "short",
  });
  let formattedDate = dateObject.toLocaleDateString("en-US", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });
  let formattedTime = dateObject.toLocaleTimeString("en-US", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  });
  let formattedDateTime = `${formattedDate}`;

  return formattedDateTime;
};

export const exactMonthtDate = (timestamp) => {
  let milliseconds = timestamp * 1000;
  let dateObject = new Date(milliseconds);

  const day = String(dateObject.getDate()).padStart(2, "0");
  const month = dateObject.toLocaleString("en-US", { month: "short" });
  const year = dateObject.getFullYear();

  return `${day}-${month}-${year}`;
};

export const getChatTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const hours = date.getHours();
  const minutes = date.getMinutes();

  const ampm = hours >= 12 ? "pm" : "am";
  const formattedHours = hours % 12 === 0 ? 12 : hours % 12;
  const formattedMinutes = minutes < 10 ? `0${minutes}` : minutes;

  return `${formattedHours}:${formattedMinutes} ${ampm}`;
};

export const getChatDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const today = new Date();
  const oneDay = 24 * 60 * 60 * 1000;
  const oneWeek = 7 * oneDay;
  if (isSameDay(today, date)) {
    return "Today";
  } else if (today - date <= oneWeek) {
    const daysOfWeek = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];
    const dayOfWeek = daysOfWeek[date.getDay()];
    return dayOfWeek;
  } else {
    const options = { month: "short", day: "numeric", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  }
};
const isSameDay = (date1, date2) => {
  return (
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate()
  );
};

export const timeDifferenceInHours = (timestamp1, timestamp2) => {
  const date1 = new Date(timestamp1 * 1000);
  const date2 = new Date(timestamp2 * 1000);
  const timeDifferenceMs = Math.abs(date2 - date1);
  const timeDifferenceHours = Math.ceil(timeDifferenceMs / (1000 * 60 * 60));
  return `${timeDifferenceHours}`;
};

export function timeStampToDDMMYYYY(timestampone) {
  const timestamp = timestampone * 1000;
  const date = new Date(timestamp);
  const now = Date.now();
  const secondsAgo = Math.floor((now - timestamp) / 1000);
  if (secondsAgo < 60) {
    return formatDate(date);
  } else if (secondsAgo < 3600) {
    return formatDate(date);
  } else if (secondsAgo < 86400) {
    return formatDate(date);
  } else if (secondsAgo < 2592000) {
    return formatDate(date);
  } else if (secondsAgo < 31104000) {
    return formatDate(date);
  } else {
    return formatDate(date);
  }
}
function formatDate(date) {
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

export function getDateTimeFormatted(timestamp) {
  // Use the provided timestamp or default to the current date and time
  const dateObj = timestamp ? new Date(timestamp) : new Date();

  // Extract date
  const date = dateObj.toISOString().split("T")[0]; // Format: YYYY-MM-DD

  // Extract hours and minutes
  let hours = dateObj.getHours();
  const minutes = String(dateObj.getMinutes()).padStart(2, "0");

  // Determine AM or PM
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert hours to 12-hour format
  hours = hours % 12 || 12; // Convert 0 to 12 for midnight

  // Combine into final time
  const time = `${hours}:${minutes} ${ampm}`;

  return `${date} ${time}`;
}

export const calculateTimeDifference = (orderDateStr, processedDateStr) => {
  const orderDate = new Date(orderDateStr * 1000);
  const processedDate = new Date(processedDateStr * 1000);
  const timeDifference = processedDate - orderDate;
  const minutesDifference = timeDifference / (1000 * 60);
  if (minutesDifference < 1) {
    return "";
  } else if (minutesDifference < 60) {
    const roundedMinutes = Math.round(minutesDifference);
    return `${roundedMinutes} minutes`;
  } else {
    // Convert minutes to hours
    const hoursDifference = minutesDifference / 60;
    if (hoursDifference === 1) {
      return "1 hour";
    } else if (hoursDifference < 24) {
      const roundedHours = Math.round(hoursDifference);
      return `${roundedHours} hours`;
    } else {
      // Convert hours to days
      const daysDifference = Math.ceil(hoursDifference / 24);
      return `${daysDifference} day${daysDifference > 1 ? "s" : ""}`;
    }
  }
};

export function areTimestampsOnSameDay(timestamp1, timestamp2) {
  const date1 = new Date(timestamp1 * 1000);
  const date2 = new Date(timestamp2 * 1000);
  const isSameDay =
    date1.getFullYear() === date2.getFullYear() &&
    date1.getMonth() === date2.getMonth() &&
    date1.getDate() === date2.getDate();
  const options = { month: "short", day: "2-digit", year: "numeric" };
  const formattedDate = date2.toLocaleDateString("en-US", options);
  return { isSameDay, formattedDate };
}

export const isValidFile = function (e, allowedTypes) {
  const files = e.target.files;
  if (files.length === 1) {
    var ext = files[0]?.name?.match(/\.([^\.]+)$/)[1];
    if (allowedTypes.indexOf(ext.toLowerCase()) !== -1) {
      return true;
    } else {
      return false;
    }
  } else if (files.length > 1) {
    for (let i = 0; i < files.length; i++) {
      var ext = files[i]?.name?.match(/\.([^\.]+)$/)[1];
      if (allowedTypes.indexOf(ext) == -1) {
        return false;
      }
    }
    return true;
  }
};

export function formatCreatedAt(createdAt) {
  const date = new Date(createdAt);
  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  const dateString = date.toLocaleDateString(undefined, options);
  return `${dateString} `;
}

export function formatCreatedAtOne(createdAt) {
  // Check if createdAt is in seconds and convert to milliseconds
  const timestamp = createdAt < 1e12 ? createdAt * 1000 : createdAt;
  const date = new Date(timestamp);

  const options = {
    day: "2-digit",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };

  return date.toLocaleString("en-US", options);
}

export const getExactDate = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const options = { month: "short", day: "numeric", year: "numeric" };
  return date.toLocaleDateString("en-US", options);
};

export const getDateWithTime = (timestamp) => {
  const date = new Date(timestamp * 1000);
  const options = {
    month: "short",
    day: "numeric",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  return date.toLocaleDateString("en-US", options);
};

export const CheckApiRateLimitError = (statusCode, error) => {
  if (statusCode === 429) {
    return { data: error.response.data, status: 429 };
  } else {
    return { response: JSON.parse(JSON.stringify(error)) };
  }
};

export const generateRandomTimeStamp = () => {
  const currentDate = new Date();
  const oneWeekAgo = new Date(currentDate.getTime() - 7 * 24 * 60 * 60 * 1000);
  const oneMonthAgo = new Date(
    currentDate.getTime() - 30 * 24 * 60 * 60 * 1000
  );
  const random = Math.floor(Math.random() * 4);
  if (random === 0) {
    return (
      Math.floor(oneWeekAgo.getTime() / 1000) +
      Math.floor(Math.random() * 7 * 24 * 60 * 60)
    );
  } else {
    return (
      Math.floor(oneMonthAgo.getTime() / 1000) +
      Math.floor(Math.random() * 30 * 24 * 60 * 60)
    );
  }
};

export const generateRandomRating = () => {
  const totalCount = Math.floor(Math.random() * 20) + 80;

  // Allocate a minimum count for 5 and 4-star ratings
  const minFiveStar = Math.floor(totalCount * 0.4); // Aim for at least 35% 5-star ratings
  const minFourStar = Math.floor(totalCount * 0.2); // Aim for at least 20% 4-star ratings
  let remainingCount = totalCount - minFiveStar - minFourStar;

  // Distribute remaining counts among 3, 2, and 1-star ratings
  const remainingWeights = {
    threeStar: 0.25,
    twoStar: 0.15,
    oneStar: 0.0,
  };

  const ratingInfo = { fiveStar: minFiveStar, fourStar: minFourStar };

  for (const rating in remainingWeights) {
    const count = Math.floor(
      Math.random() *
        remainingCount *
        (remainingWeights[rating] /
          Object.values(remainingWeights).reduce((a, b) => a + b, 0))
    );
    ratingInfo[rating] = count;
    remainingCount -= count;
  }

  // Distribute leftover counts proportionally
  for (const rating in remainingWeights) {
    const additionalCount = Math.round(
      remainingCount *
        (remainingWeights[rating] /
          Object.values(remainingWeights).reduce((a, b) => a + b, 0))
    );
    ratingInfo[rating] += additionalCount;
    remainingCount -= additionalCount;
  }

  // Calculate average rating
  const rating = Number(
    (
      (5 * ratingInfo.fiveStar +
        4 * ratingInfo.fourStar +
        3 * ratingInfo.threeStar +
        2 * ratingInfo.twoStar +
        1 * ratingInfo.oneStar) /
      totalCount
    ).toFixed(1)
  );

  return { totalCount, ratingInfo, rating };
};

const getInputSelectField = (key, reference) => {
  const field = reference.find(
    (item) => item.key === key && item.type === "INPUT_SELECT"
  );
  if (field) {
    return {
      label: field.name,
      name: field.key,
      options: field.options.map((option) => ({
        key: option.key.toLowerCase(),
        name: option.name,
      })),
    };
  }
  return null;
};

export function formatUpdatedAt(dateString) {
  const date = new Date(dateString);

  // Extract day, month, and year
  const day = date.getDate().toString().padStart(2, "0"); // Ensures 2-digit day
  const month = date.toLocaleString("default", { month: "short" }); // Abbreviated month
  const year = date.getFullYear().toString().slice(-2); // Last 2 digits of the year

  return `${day}/${month}/${year}`;
}

// Example usage
const updatedAt = "2024-12-14T12:36:58.141Z";

export function formatToIndianNumbering(num) {
  // if (isNaN(num) || num < 0) return "Invalid input";

  // // Convert the number into crores, lakhs, or thousands
  // if (num >= 10000000) {
  //     return (num / 10000000).toFixed(4) + " cr";
  // } else if (num >= 100000) {
  //     return (num / 100000).toFixed(4) + " lakh";
  // } else if (num >= 1000) {
  //     return (num / 1000).toFixed(4) + " k";
  // } else {
  //     return num.toFixed(2) + 'Rupees'; // If less than 1000, just show the number
  // }
  return num;
}

export function convertPrice(value) {
  const formatNumber = (num) => {
    return num % 1 === 0 ? num.toFixed(0) : parseFloat(num.toFixed(2));
  };

  if (value < 10000) {
    return value.toLocaleString() + " /-";
  } else if (value < 100000) {
    return formatNumber(value / 1000) + " K";
  } else if (value < 10000000) {
    return formatNumber(value / 100000) + " L";
  } else {
    return formatNumber(value / 10000000) + " Cr";
  }
}
export function convertPriceOne(value) {
  const formatNumber = (num) => {
    return num % 1 === 0 ? num.toFixed(0) : parseFloat(num.toFixed(2));
  };

  if (value < 10000) {
    return value.toLocaleString() + "";
  } else if (value < 100000) {
    return formatNumber(value / 1000) + " K";
  } else if (value < 10000000) {
    return formatNumber(value / 100000) + " L";
  } else {
    return formatNumber(value / 10000000) + " Cr";
  }
}

export function newconvertPrice(value) {
  if (value < 999) {
    return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",") + " /-";
  } else if (value < 100000) {
    return (value / 1000).toFixed(1) + " " + "K";
  } else if (value < 10000000) {
    return (value / 100000).toFixed(2) + " " + "L";
  } else {
    return (value / 10000000).toFixed(2) + "  " + "Cr";
  }
}
export function shortMonthYearText(input) {
  if (!input) {
    return "";
  }
  if (input.toLowerCase() === "monthly") {
    return "m";
  } else if (input.toLowerCase() === "yearly") {
    return "yr";
  } else {
    return "";
  }
}

// export function timeStampToDays(timestampone) {
//   const timestamp = timestampone * 1000;
//   const now = Date.now();
//   let secondsAgo = Math.floor((now - timestamp) / 1000);
//   secondsAgo = Math.max(0, secondsAgo);

//   if (secondsAgo < 60) {
//     return secondsAgo + " second" + (secondsAgo === 1 ? "" : "s") + " ago";
//   } else if (secondsAgo < 3600) {
//     const minutesAgo = Math.floor(secondsAgo / 60);
//     return minutesAgo + " min" + (minutesAgo === 1 ? "" : "s") + " ago";
//   } else if (secondsAgo < 86400) {
//     const hoursAgo = Math.floor(secondsAgo / 3600);
//     return hoursAgo + " hour" + (hoursAgo === 1 ? "" : "s") + " ago";
//   } else if (secondsAgo < 2592000) {
//     const daysAgo = Math.floor(secondsAgo / 86400);

//     if (daysAgo < 7) {
//       return daysAgo + " day" + (daysAgo === 1 ? "" : "s") + " ago";
//     } else if (daysAgo < 29) {
//       const weeksAgo = Math.floor(secondsAgo / 604800);
//       return weeksAgo + " week" + (weeksAgo === 1 ? "" : "s") + " ago";
//     }
//   } else if (secondsAgo < 31104000) {
//     const monthsAgo = Math.floor(secondsAgo / 2592000);
//     return monthsAgo + " month" + (monthsAgo === 1 ? "" : "s") + " ago";
//   } else {
//     const yearsAgo = Math.floor(secondsAgo / 31536000);
//     return yearsAgo + " year" + (yearsAgo === 1 ? "" : "s") + " ago";
//   }
// }



const plural = (n, unit) => `${n} ${unit}${n === 1 ? "" : "s"}`;
export function timeStampToDays(timestampone) {
  const timestamp = timestampone * 1000;
  const now = Date.now();
  let secondsDiff = Math.floor((now - timestamp) / 1000);

  if (secondsDiff < 0) {
    // Future timestamp
    secondsDiff = Math.abs(secondsDiff);
    if (secondsDiff < 60) return `in ${plural(secondsDiff, "second")}`;
    if (secondsDiff < 3600) return `in ${plural(Math.floor(secondsDiff / 60), "minute")}`;
    if (secondsDiff < 86400) return `in ${plural(Math.floor(secondsDiff / 3600), "hour")}`;
    return `in ${plural(Math.floor(secondsDiff / 86400), "day")}`;
  }

  // Past timestamps ("1 day ago", not "1 days ago")
  if (secondsDiff < 60) return `${plural(secondsDiff, "second")} ago`;
  if (secondsDiff < 3600) return `${plural(Math.floor(secondsDiff / 60), "minute")} ago`;
  if (secondsDiff < 86400) return `${plural(Math.floor(secondsDiff / 3600), "hour")} ago`;
  if (secondsDiff < 2592000) return `${plural(Math.floor(secondsDiff / 86400), "day")} ago`;
  if (secondsDiff < 31104000) return `${plural(Math.floor(secondsDiff / 2592000), "month")} ago`;
  return `${plural(Math.floor(secondsDiff / 31536000), "year")} ago`;
}



export const formatNumber = (num) => {
  if (num < 1000) {
    return num;
  }
  return Number(num).toLocaleString("en-IN");
};

export const getSerialNumber = (rowIndex, paginationData) => {
  const pageIndex = paginationData?.pageIndex ?? 1;
  const pageSize = paginationData?.pageSize ?? 10;
 
  return (pageIndex - 1) * pageSize + (rowIndex + 1);
};

// Percent-encode ONE path segment so ANY character a filename can carry —
// spaces, ( ) [ ] , & # ' etc. — is escaped, keeping the URL valid in BOTH an
// <img src> and a CSS url(). R2/S3 decode it back to the real object key, so the
// file still resolves.
//   • decode first so a segment that's ALREADY encoded ("%20") normalises
//     instead of double-encoding ("%2520"); an invalid lone "%" falls back to
//     encoding the raw segment.
//   • encodeURIComponent deliberately leaves ! ' ( ) * un-escaped — and raw
//     parentheses break an unquoted CSS url() — so escape those too (the
//     standard RFC-3986 augmentation).
const encodeSegment = (seg) => {
  let raw = seg;
  try {
    raw = decodeURIComponent(seg);
  } catch {
    /* not valid percent-encoding — treat the segment as literal */
  }
  return encodeURIComponent(raw).replace(
    /[!'()*]/g,
    (c) => "%" + c.charCodeAt(0).toString(16).toUpperCase()
  );
};

// Encode every "/"-separated segment of a path, leaving the slashes intact.
const encodePath = (p) => p.split("/").map(encodeSegment).join("/");

export const getImageUrl = (path, ADMIN_S3_BASE_URI, S3_BASE_URI) => {
  if (!path) return "";

  // New uploads store the full CDN URL (e.g. R2 https://pub-...r2.dev/...) in
  // `path`; keep the origin + query/hash and only re-encode the path so any
  // special character in the filename can't break the <img src> or a CSS url().
  // Rebuild from origin + encoded path (rather than assigning url.pathname,
  // which the URL serializer decodes back to raw parens). Older records store a
  // bucket-relative key, which gets the base prepended below.
  if (/^https?:\/\//i.test(path)) {
    try {
      const url = new URL(path);
      return url.origin + encodePath(url.pathname) + url.search + url.hash;
    } catch {
      return path; // malformed URL — hand it back untouched
    }
  }

  const isAdminImage = path.includes("admin/");
  const baseUrl = isAdminImage ? ADMIN_S3_BASE_URI : S3_BASE_URI;
  const cleanPath = path.replace(/^\/+/, "");
  return `${baseUrl}/${encodePath(cleanPath)}`;
};
